import React from 'react'
import * as UI from 'ui'
import LatestMessageDashboardWidget from 'widgets/dashboard/LatestMessageDashboardWidget'
import WhenDeviceNotAuthorized from 'support/conditionals/WhenDeviceNotAuthorized'
import { Can } from '@morningtrain/react-auth'
import Permissions from 'services/Permissions'
import { OnNavigatePipeline } from '@morningtrain/react-navigation'
import { MountSmartviewOnPipe } from '@morningtrain/react-smartviews'
import ForecastSummaryDashboardSmartview from 'widgets/dashboard/smartviews/ForecastSummaryDashboardSmartview'
import RevenueSummaryDashboardWidget from 'widgets/dashboard/RevenueSummaryDashboardWidget'
import GuestSummaryDashboardWidget from 'widgets/dashboard/GuestSummaryDashboardWidget'
import WageRatioSummaryDashboardWidget from 'widgets/dashboard/WageRatioSummaryDashboardWidget'
import RevenueChartDashboardWidget from 'widgets/dashboard/RevenueChartDashboardWidget'
import EmployeeShiftsDashboardWidget from 'widgets/dashboard/EmployeeShiftsDashboardWidget'
import MyOnboardingDashboardWidget from 'widgets/dashboard/MyOnboardingDashboardWidget'
import WhenDeviceAuthorized from 'support/conditionals/WhenDeviceAuthorized'
import UserSalesPerformanceDashboardWidget from 'widgets/dashboard/UserSalesPerformanceDashboardWidget'
import DepartmentSalesPerformanceDashboardWidget from 'widgets/dashboard/DepartmentSalesPerformanceDashboardWidget'
import MyMessagesDashboardWidget from 'widgets/dashboard/MyMessagesDashboardWidget'
import ChecklistsTodayDashboardSmartview from 'widgets/dashboard/smartviews/ChecklistsTodayDashboardSmartview'
import MyShiftsSmartview from 'widgets/dashboard/smartviews/MyShiftsSmartview'
import {Env} from "@morningtrain/helpers";

export default function DashboardContent () {
  const hasWaiter = Env.get('globals.has_waiter');
  const hasKitchen = Env.get('globals.has_kitchen');

  return (
    <UI.CardGroup>

      <LatestMessageDashboardWidget />

      <WhenDeviceNotAuthorized>
        <Can permission={Permissions.DASHBOARD_FULL}>
          <Can permission={Permissions.SHIFTS_ADJUST_FORECAST}>
            <OnNavigatePipeline>
              <MountSmartviewOnPipe smartview={<ForecastSummaryDashboardSmartview />} replace />
            </OnNavigatePipeline>
          </Can>
          <Can permission={Permissions.SHIFTS_ADJUST_FORECAST} negate>
            <OnNavigatePipeline>
              <MountSmartviewOnPipe smartview={<MyShiftsSmartview />} replace />
            </OnNavigatePipeline>
          </Can>
          <UI.FlexGrid responsive={{ md: 3 }}>
            <RevenueSummaryDashboardWidget />
            <GuestSummaryDashboardWidget />
            <WageRatioSummaryDashboardWidget />
          </UI.FlexGrid>
          <RevenueChartDashboardWidget />
          <UI.FlexGrid responsive={{ md: 2 }}>
            {hasKitchen && <EmployeeShiftsDashboardWidget category='kitchen' />}
            {hasWaiter && <EmployeeShiftsDashboardWidget category='waiter' />}
          </UI.FlexGrid>

        </Can>

        <Can permission={Permissions.DASHBOARD_PERSONAL}>
          <Can permission={Permissions.DASHBOARD_FULL} negate>
            <OnNavigatePipeline>
              <MountSmartviewOnPipe smartview={<MyShiftsSmartview />} replace />
            </OnNavigatePipeline>
          </Can>
          <MyOnboardingDashboardWidget />
        </Can>

      </WhenDeviceNotAuthorized>

      <WhenDeviceAuthorized>
        <Can permission={Permissions.DASHBOARD_TABLET}>
          <Can permission={Permissions.FINANCIALS_PERFORMANCE_VIEW}>
            <UI.FlexGrid cols={1} responsive={{ lg: 3 }}>
              <RevenueSummaryDashboardWidget tablet />
              <GuestSummaryDashboardWidget tablet />
              <WageRatioSummaryDashboardWidget tablet />
            </UI.FlexGrid>
          </Can>
        </Can>
      </WhenDeviceAuthorized>

      <Can permission={Permissions.FINANCIALS_PERFORMANCE_VIEW}>
        <UserSalesPerformanceDashboardWidget />
        <DepartmentSalesPerformanceDashboardWidget />
      </Can>

      <MyMessagesDashboardWidget />

    </UI.CardGroup>
  )
}
